(function () {
  'use strict';

  // ── Top-level nav menus (hdt-header-menu) ──────────────────────────────────
  // Horizon's hdt-header-menu checks for detail.offClick on click events:
  //   if (!t?.detail?.offClick && data-url && event==="hover") → navigate
  // Dispatching CustomEvent('click', {detail:{offClick:true}}) signals Horizon
  // to TOGGLE the menu instead of navigate (hover-mode only).

  function initMenu(host) {
    var details = host.querySelector('details');
    if (!details) return;

    var summary = details.children[0];
    if (!summary || summary.tagName.toLowerCase() !== 'summary') return;

    var isHover = host.getAttribute('event') === 'hover';

    // aria-expanded: set initial value and keep in sync for ALL menu types
    // (previous version only did this for hover-mode — click-mode menus were skipped)
    summary.setAttribute('aria-expanded', String(details.hasAttribute('open')));
    new MutationObserver(function () {
      summary.setAttribute('aria-expanded', String(details.hasAttribute('open')));
    }).observe(details, { attributes: true, attributeFilter: ['open'] });

    // Hover-mode only: intercept Enter/Space → toggle instead of navigate.
    // Click-mode <details> already toggles natively on Enter/Space.
    if (isHover) {
      summary.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        summary.dispatchEvent(new CustomEvent('click', {
          bubbles: true,
          cancelable: true,
          detail: { offClick: true }
        }));
      });
    }

    // Escape anywhere inside an open menu → close + return focus to trigger.
    // WCAG 2.1 SC 1.4.13 (Dismissible): content shown on hover/focus must be
    // dismissible without moving keyboard focus away from the trigger.
    details.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !details.hasAttribute('open')) return;
      e.preventDefault();
      e.stopPropagation();
      summary.dispatchEvent(new CustomEvent('click', {
        bubbles: true,
        cancelable: true,
        detail: { offClick: true }
      }));
      summary.focus();
    });
  }

  // ── Sub-menu accordions (hdt-accordion inside dropdowns) ───────────────────
  // Keep aria-expanded on <summary> in sync with <details [open]>.
  // The Liquid template placed aria-expanded on <details> (wrong element);
  // ARIA 1.2 requires it on the interactive trigger (<summary>).

  function initAccordion(accordion) {
    var details = accordion.querySelector('details');
    if (!details) return;

    var summary = details.querySelector('summary');
    if (!summary) return;

    summary.setAttribute('aria-expanded', String(details.hasAttribute('open')));
    new MutationObserver(function () {
      summary.setAttribute('aria-expanded', String(details.hasAttribute('open')));
    }).observe(details, { attributes: true, attributeFilter: ['open'] });
  }

  // ── Bootstrap ───────────────────────────────────────────────────────────────

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('hdt-header-menu').forEach(initMenu);
    root.querySelectorAll('.hdt-sub-menu hdt-accordion').forEach(initAccordion);
  }

  function init() {
    scan(document);

    // Handle menus injected after page load (predictive search, etc.)
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          var tag = node.tagName && node.tagName.toLowerCase();
          if (tag === 'hdt-header-menu') initMenu(node);
          if (tag === 'hdt-accordion') initAccordion(node);
          scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
